import { render } from "./accept-icon.vue?vue&type=template&id=3415b22a"
const script = {}
script.render = render

export default script